export default __webpack_public_path__ + "static/media/Thumbnail-Newsletter-3.8c353e37.png";